<template>
    <div>
        <product-view-component :type="3"></product-view-component>
    </div>
</template>
<script>
import productPreviewComponent from "@/components/ProductPreviewComponent.vue"

export default {
    components: {
        "product-view-component": productPreviewComponent
    }
}
</script>
<style scoped lang="less">

</style>